import styles from './../../assets/styles/default.scss';

const muiBadgeTheme = (theme) => {
  theme.overrides.MuiBadge = {
    colorPrimary: {
      main: styles.error,
      light: styles.errorLight,
      dark: styles.errorDark,
      contrastText: styles.errorContrast,
    },
  };
};

export default muiBadgeTheme;
